// extracted by mini-css-extract-plugin
export default {"scrollMargin":"CoreParagraph-module__scrollMargin-oc23Po"};